"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

require("./alert.less");

var Alert = function (_super) {
  __extends(Alert, _super);

  function Alert(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    return _this;
  }

  Alert.prototype.render = function () {
    var _this = this;

    if (!this.state.dismissed) {
      return React.createElement("div", {
        style: {
          position: "absolute",
          zIndex: 15,
          right: 15,
          width: 300
        }
      }, React.createElement("div", {
        className: "alert notification notification--reveal",
        "data-animation": "from-right"
      }, React.createElement("div", {
        className: "alert__body"
      }, this.props.children), React.createElement("div", {
        className: "alert__close",
        onClick: function onClick() {
          _this.setState({
            dismissed: true
          });
        }
      }, "\xD7")));
    } else {
      return null;
    }
  };

  return Alert;
}(React.Component);

exports["default"] = Alert;